'use client';

import React, { FC } from 'react';
import style from './ContentBanner.module.scss';
import { useModalContext } from '@/context/ModalsContext';
import { usePathname } from 'next/navigation';
import { getBookAppointmentUrl } from '@/lib/bookAppointment';

interface IProps {
  title: string;
  description: string;
  withButton: boolean;
  bookServiceButton?: boolean;
}

export const ContentBanner: FC<IProps> = ({
  title,
  description,
  withButton: withContactButton,
  bookServiceButton,
}) => {
  const { setIsModalOpened } = useModalContext();
  const pathname = usePathname();
  const bookAppointmentUrl = getBookAppointmentUrl(pathname);

  return (
    <div>
      <div className={style.wrapper}>
        <div className={style.wrapperInner}>
          <h3 className="mb-6 text-2xl font-semibold">{title}</h3>
          <p
            className="description-with-links text-lg"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </div>
      </div>

      {withContactButton && (
        <button
          onClick={() => setIsModalOpened(true)}
          className="ring-offset-background focus-visible:ring-ring m-auto mt-2 flex h-10 items-center justify-center whitespace-nowrap rounded-md bg-black px-5 py-6 text-lg font-medium text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
        >
          Contact Us
        </button>
      )}

      {bookServiceButton && (
        <button
          onClick={() => window.open(bookAppointmentUrl, '_blank')}
          className="ring-offset-background focus-visible:ring-ring m-auto mt-2 flex h-10 items-center justify-center whitespace-nowrap rounded-md bg-black px-5 py-6 text-lg font-medium text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
        >
          Request Service
        </button>
      )}
    </div>
  );
};
